
import store from '@/store'
const userRole = store.state.user?.role

export default [{
  
  _name: 'CSidebarNav',
  _children: [
    userRole == 2 &&{


      _name: 'CSidebarNavItem',
      name: 'Satistiques',
      to: '/Statistiques',
      icon: 'cil-speedometer',
    },
   

    
 /* nouveau */
    userRole == 2 &&{
      _name: 'CSidebarNavDropdown',
      name: 'Nouveau',
     
      icon: 'cil-pencil',
      items: [
        {
          name: 'Service',
          to: '/ajouterService',
         
        },
        {
          name:' Vidange',
          to: '/ajouter_vid_man',
          
        },
       /*  {
          name: 'Vidange passagé',
          to: '/Annonce/Mes_reclamations',
         
        }, */


       
      ]
    },

userRole == 2 &&{
  _name: 'CSidebarNavItem',
  name: 'Recherche Facture',
  to: '/recherche_num_facture',
  icon: 'cil-star',
  beforeEnter: (to, from, next) => {
    if (store.state.loggedIn == false) next("/accueil");
    next();
  }
}, 
/* lsites societe */
userRole == 2 &&{
  _name: 'CSidebarNavItem',
  name: 'Listes Retenues',
  to: '/listesRetenues',
  icon: 'cil-star',
  beforeEnter: (to, from, next) => {
    if (store.state.loggedIn == false) next("/accueil");
    next();
  }
}, 

/* autre  */
userRole == 2 &&{
  _name: 'CSidebarNavDropdown',
  name: 'Autre Ajout',
  route: '/listes_services_ajouter',
  icon: 'cil-pencil',
  items: [{
      name:'Societé',
      to: '/ajout_societe',
      badge: {
        color: 'primary',
        text: 'Nouveau',
      },
      
    },
    {
      name: 'Matricule',
      to: '/ajout_matr',
      badge: {
        color: 'primary',
        text: 'Nouveau',
      },
     
    },


   
  ]
},
 
userRole == 2 && {
  _name: 'CSidebarNavItem',
  name: 'Corbeilles',
  to: '/archive',
  icon: 'cil-speedometer',
},





userRole == 1 && {
  _name: 'CSidebarNavItem',
  name: 'vidange',
  to: '/vidange',
  icon: 'cil-speedometer',
},

  
    
  ]
}]